// Platform identity for this build.
//
// The same codebase is deployed as several products -- Aitomistic Lab@XMU (an
// academic-only deployment) and the Aitomistic Hub (a commercial one) among
// them. Behaviour that differs between them must be keyed on THIS value, never
// hardcoded, because the branches merge into one another: main flows into the
// hub branch periodically, so a behaviour baked into shared code on main would
// surface on the Hub on the next merge.
//
// VITE_PLATFORM is exported by each host's own deploy script (the atom deploy
// sets `VITE_PLATFORM=atom`), NOT committed to a branch, so it cannot leak
// across deployments when branches merge. An unset value means "not a
// special-cased platform" and every academic-only behaviour stays off -- the
// safe default that leaves the Hub exactly as it is.
export const PLATFORM: string = import.meta.env.VITE_PLATFORM ?? '';

// Aitomistic Lab@XMU verifies that registrants are academic before granting
// access. The Hub and every other deployment do not.
export const isAcademicOnly: boolean = PLATFORM === 'atom';

// Aitomistic Hub — the commercial deployment.
export const isHub: boolean = PLATFORM === 'hub';

// NOTE: feature switches (enablePayment, enableCourseApply, enableApiAccess) and the login/brand
// presentation config now live in branding.yaml — see ./branding.ts.
